'use client';

import Image, { ImageProps } from 'next/image';
import { FC, memo, ReactElement, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { ICON_PLACEHOLDER } from '@/constants/theme';

export interface INextImageProps extends Omit<ImageProps, 'src'> {
	fallbackSrc?: string;
	src: any; //ImageProps src is not well exported by NextImage so for now, using src
	imgClass?: string;
	noPlaceHolderImg?: boolean;
}

const isImageValid = (source: any) => {
	return new Promise((resolve) => {
		const img = document.createElement('img');
		img.onerror = () => resolve(false);
		img.onload = () => resolve(true);
		img.src = source?.src ? source.src : source;
	});
};

const NextImage: FC<INextImageProps> = ({
	noPlaceHolderImg,
	imgClass,
	src,
	fallbackSrc = '',
	...props
}): ReactElement => {
	const [imgSrc, setImgSrc] = useState<unknown>();

	/**
	 * Fix issue where error image is not showing up properly on next image
	 * onError is unfortunately not getting triggered
	 */
	useEffect(() => {
		const loadImage = async () => {
			const isValid = await isImageValid(src);
			setImgSrc(isValid ? src : fallbackSrc);
		};
		loadImage();
	}, [src, fallbackSrc]);

	return imgSrc ? (
		// @ts-ignore
		<Image {...props} src={imgSrc} alt={props.alt} />
	) : (
		<>
			{!noPlaceHolderImg ? (
				// eslint-disable-next-line @next/next/no-img-element
				<img
					src={ICON_PLACEHOLDER}
					alt="Placeholder"
					width={24}
					height={24}
					className={twMerge(`w-full ${imgClass || ''}`)}
				/>
			) : null}
		</>
	);
};

export default memo(NextImage);
